/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import FilterPanel from 'app/components/EditorComponents/FilterPanel.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class RouteFilterPanel extends React.Component {
    render() {
        let andFilter = (this.props.route.andFilter) ? this.props.route.andFilter : '',
			orFilter = (this.props.route.orFilter) ? this.props.route.orFilter : '',
			notFilter = (this.props.route.notFilter) ? this.props.route.notFilter : '',
			behavior = (this.props.route.filterBehavior) ? this.props.route.filterBehavior : 0,
			titleActive = (this.props.route.filtersTitle) ? true : false,
			categoryActive = (this.props.route.filtersCategory) ? true : false,
			contentActive = (this.props.route.filtersContent) ? true : false,
			authorActive = (this.props.route.filtersAuthor) ? true : false,
			linkActive = (this.props.route.filtersLink) ? true : false;

        return (
            <FilterPanel
                {...this.props}
				updateField={this.props.changeHandler}
				andFilter={andFilter}
				orFilter={orFilter}
				notFilter={notFilter}
				behavior={behavior}
				titleActive={titleActive}
				categoryActive={categoryActive}
				contentActive={contentActive}
				authorActive={authorActive}
                linkActive={linkActive}
                stateName="route"
                errors={this.props.errors} />
        );
    }

};

RouteFilterPanel.displayName = "RouteFilterPanel";

RouteFilterPanel.propTypes = {
    route: PropTypes.object,
    routeViewType: PropTypes.number,
    userPerms: PropTypes.object,
    changeHandler: PropTypes.func,
    errors: PropTypes.object
};

RouteFilterPanel.defaultProps = {
    route: {},
    routeViewType: 0,
    userPerms: {},
    changeHandler: null,
    errors: null
};

export default ComponentWithContext(RouteFilterPanel);
